/**
 * PWA 全局变量
 */

export const usePWAPrompt = () => useState<any>('pwa_prompt', () => null )

export const useNeverPrompt = () => useState<boolean>('never_prompt', () => localStorage.getItem('pwa_never_prompt') === 'never')

export const usePWAPromptPopup = () => useState<boolean>('pwa_prompt_popup', () => false)
